import React from "react";

/**
 * Row / header checkbox for bulk selection. Ships an indeterminate state
 * (checked=false + `indeterminate=true`) so the header can show "some
 * selected" when only part of the visible set is picked.
 *
 * Every checkbox emits `data-testid` derived from `testId` so drivers can
 * target rows by record id.
 */
export function BulkCheckbox({
    checked,
    indeterminate = false,
    onChange,
    onClick,
    disabled = false,
    ariaLabel,
    testId,
    className = "",
}) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (ref.current) ref.current.indeterminate = !!indeterminate && !checked;
    }, [indeterminate, checked]);

    return (
        <input
            ref={ref}
            type="checkbox"
            checked={!!checked}
            disabled={disabled}
            onClick={onClick}
            onChange={(e) => onChange?.(e.target.checked)}
            aria-label={ariaLabel}
            data-testid={testId}
            className={`h-4 w-4 rounded border-[#D1D5DB] text-[#3E9E2E] focus:ring-[#3E9E2E] cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
        />
    );
}
